<template>
    <div>
        <checkbox
            v-for="option in options"
            
            class="option"

            :value="option.value === value"
            :label="option.label"
            :disabled="!enabledOptions.includes(option.value)"
            
            @input="$emit('input', $event ? option.value : undefined)"
        />
    </div>
</template>

<script>

export default {
    name: "RadioCheckboxCollection",
    
    props: {
        /**
         * @type { Array<{ value: String, label: String }> }
         */
        options: {
            type: Array,
            required: true
        },
        
        enabledOptions: {
            type: Array,
            required: true
        },
        
        value: {
            type: String,
            required: false
        }
    }
}
</script>

<style scoped lang="scss">
    .option {
        display: inline-block;
    
        &:not(:first-child){
            padding-left: 10px;
        }
    }
</style>